module.exports = __webpack_public_path__ + "static/media/kawaconn.7e0a9bf3.png";